// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"e6b6c4af","285":"b48f209b","449":"5f7a25f5","496":"a663730f","667":"90efafd0","818":"28e7fb60","829":"b4fc1402","917":"7065b8f1"}[chunkId] + ".chunk.js";
};